<div class="container p-4">
    <div class="row d-flex justify-content-center">
        <button type="button" class="btn-close" aria-label="Close" (click)="closeModal()"></button>
        <div class="col-12 text-center modal-title mb-4">{{'ASSISTANCE.ASSISTANCE_TITLE' | translate}}</div>
        <div class="col-12 text-center modal-subtitle mb-4">{{'ASSISTANCE.ASSISTANCE_SUBTITLE' | translate}}</div>
    </div>
    <div class="row">
        <div class="col-12 text-center font-16 lh-lg">
            <p>Scrivi una mail all'indirizzo<br>
                <span><a href="mailto:wrp-team@noovle.com">wrp-team@noovle.com</a></span><br> descrivendo il
                problema.<br> Verrai contattato al più presto.
            </p>
        </div>
    </div>
</div>